import ObserversInput from './ObserversInput'

export default ObserversInput
